module.exports = __webpack_public_path__ + "suriname.svg?bd4753be50666579e4d11eb1d35ead67";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/suriname.svg
// module id = 308
// module chunks = 10